import { Alert, Box, TextField } from "@mui/material";
import React from "react";
import BaseButton from "../../../components/NewDevelopment/Common/Buttons/BaseButton";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";

const DurationFilter = ({ obj }) => {
  const {
    mainState,
    arraMapped,
    allCallStatus,
    outComefilter,
    onChange,
    onCustomDurationChange,
    customDurationError,
    handleClearDurationFilter,
  } = obj;
  return (
    <Box className="mt-2">
      <span className="font-12-grey">Duration</span>
      <Box className="mt-2 duration-filter-container">
        {arraMapped.map((arr, index) => (
          <Box key={index} sx={{ paddingTop: "4px" }}>
            <Box className="flex-evenly">
              {arr.innerMap?.map((innerArr, i) => {
                const dur = arr?.title === "Filter Calls with status";
                const isSelected = arr?.isObject
                  ? outComefilter.find((o) => o === innerArr?.tag)
                  : mainState[arr?.valueAssigned] === innerArr ||
                    mainState[arr?.valueAssigned].includes(innerArr);

                return (
                  <Box key={i}>
                    <Box
                      onClick={() => onChange(arr?.valueAssigned, innerArr)}
                      className="flex-xy-center cursor-pointer"
                      sx={{
                        width: "70px",
                        height: "32px",
                        borderRadius: "100px",
                        background: isSelected ? "#FFFFFF" : "#F1F4FA",
                      }}
                    >
                      <span className="font-12-lightgrey">
                        {!arr?.isObject &&
                          (dur ? allCallStatus[innerArr] : innerArr)}
                        {arr?.isObject && innerArr?.name}
                      </span>
                    </Box>
                  </Box>
                );
              })}
            </Box>
          </Box>
        ))}
      </Box>
      {mainState?.durationFilter === "Custom" && (
        <Box>
          <span className="font-12-lightgrey mt-2">Custom Duration</span>
          <Box
            className="flex-between"
            sx={{
              gap: 1,
            }}
          >
            <TextField
              placeholder="from (in sec.)"
              name="min"
              type="number"
              value={mainState?.min}
              onChange={onCustomDurationChange}
              sx={commonStyles.inputField}
              slotProps={{
                htmlInput: { min: 0 },
              }}
            />
            <TextField
              style={{ width: "160px" }}
              placeholder="to (in sec.)"
              name="max"
              type="number"
              value={mainState?.max}
              onChange={onCustomDurationChange}
              sx={commonStyles.inputField}
              slotProps={{
                htmlInput: { min: 0 },
              }}
            />
          </Box>
          {customDurationError && (
            <Alert severity="error" variant="standard" sx={{ my: 1 }}>
              {customDurationError}
            </Alert>
          )}
        </Box>
      )}
      <BaseButton
        title="Clear Duration Filter"
        handleClick={handleClearDurationFilter}
        styles={{ padding: 0 }}
      />
    </Box>
  );
};

export default DurationFilter;
